import styled from '@emotion/styled';
import colors from '../../../../styling/colors';
import DefaultButton from '../../Buttons/DefaultButton';
import checkmark from '../../../../assets/images/checkmark.svg';

export const StyledForm = styled.form`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const CheckboxInput = styled.input`
  display: none;
`;

export const Label = styled.label`
  display: flex;
`;

export const DisplayCheckbox = styled.span`
  height: 1rem;
  width: 1rem;
  margin-right: 0.5rem;
  border: 1px solid ${colors('silver')};
  background: ${({ checked }) => (checked ? 'url(' + checkmark + ')' : 'none')};
`;

export const Submit = styled(DefaultButton)`
  margin-bottom: 1rem;
  width: 100%;
`;
